import React, {Component} from "react";
import SimpleModal from "../../../modules/popup/SimpleModal";
import ModalContainer from "../../../modules/commons/ModalContainer";
import Api from "../../../Services/Api";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleDate from "../../../modules/SimpleDate";
import M from "moment";
import FlexView from "react-flexview";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import * as R from "ramda";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimplePrintTable from "../../../modules/popup/SimplePrintTable";
import SimpleUploadExcel from "../../../modules/upload/SimpleUploadExcel";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {HttpStatus} from "../../common/Constants";
import {
    checkAndHandleError,
    contructQueryParam,
    fetchDataAsync,
    FormatCurrencyRupiah,
    FormatCurrencyWithoutSymbol
} from "../../../Services/Utils";
import {mapToObjectDDL} from "../../common/mapper";
import { defaultTableChange } from "../../../modules/custom/customTable";

class MasterUnitPriceModifying extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (value, tableMeta) => {
                    return <>{tableMeta.rowIndex + 1}</>;
                },
                sort: false,
            },
        },
        {
            name: "kodeVariant",
            label: "Kode Variant",
            options: {
                customBodyRender: (val, {rowIndex}) => {
                    let saved = this.state.dataToDetail[rowIndex].saved;
                    if (saved) {
                        return <>{val}</>;
                    } else {
                        return (<SimpleDDL
                            id="input_text_kode_variant"
                            box="search"
                            name="kodeVariant"
                            readOnly={!this.props.displayActive}
                            containerclassname="margin-bottom-none width width-250px"
                            styles={{
                                menu: (provided) => ({
                                    ...provided,
                                    position: "relative",
                                    fontFamily:
                                        "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                                }),
                            }}
                            options={this.state.dataVariant.map((item) => ({
                                label: item.value,
                                value: item.value,
                                namaVariant: item.label,
                            }))} // Change this line
                            value={
                                val
                                    ? this.findLabel(
                                        this.state.dataToDetail[rowIndex].kodeVariant,
                                        this.state.dataVariant.map((item) => ({
                                            label: item.value,
                                            value: item.value,
                                        }))
                                    )
                                    : ""
                            }
                            onChange={(event) => {
                                this.handleRowValueChange(rowIndex, "kodeVariant", event);
                            }}
                        />)
                    }
                }
            },
        },
        {
            name: "namaVariant",
            label: "Nama Variant",
            options: {
                customBodyRender: (val, {rowIndex}) => {
                    let save = this.state.dataToDetail[rowIndex].saved;
                    if (save) {
                        return <>{val}</>;
                    } else {
                        return (
                            <SimpleDDL
                                id="input_text_kode_variant"
                                box="search"
                                name="namaVariant"
                                readOnly={!this.props.displayActive}
                                containerclassname="margin-bottom-none width width-250px"
                                styles={{
                                    menu: (provided) => ({
                                        ...provided,
                                        position: "relative",
                                        fontFamily:
                                            "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                                    }),
                                }}
                                options={this.state.dataVariant}
                                value={this.findLabel(
                                    this.state.dataToDetail[rowIndex].kodeVariant,
                                    this.state.dataVariant
                                )}
                                onChange={(event) => {
                                    this.handleRowValueChange(rowIndex, "namaVariant", event);
                                }}
                            />
                        );
                    }
                },
            },
        },
        {
            name: "onTheRoad",
            label: "On The Road",
            options: {
                customBodyRender: (val, {rowIndex}) => {
                    let saved = this.state.dataToDetail[rowIndex].saved;
                    if (saved) {
                        return <>{FormatCurrencyRupiah({number: val})}</>;
                    } else {
                        return (
                            <SimpleInput
                                id="input_text_on_the_road"
                                name="onTheRoad"
                                containerclassname="margin-bottom-none width width-250px"
                                readOnly={!this.props.displayActive}
                                box="number"
                                value={FormatCurrencyWithoutSymbol({number: val})}
                                onValueChange={({value}) => {
                                    let target = {value: value};
                                    this.handleRowValueChange(rowIndex, "onTheRoad", target)
                                }}
                            />
                        );
                    }
                },
            },
        },
        {
            name: "offTheRoad",
            label: "Off The Road",
            options: {
                customBodyRender: (val, {rowIndex}) => {
                    let saved = this.state.dataToDetail[rowIndex].saved;
                    if (saved) {
                        return <>{FormatCurrencyRupiah({number: val})}</>;
                    } else {
                        return (
                            <SimpleInput
                                id="input_text_off_the_road"
                                name="offTheRoad"
                                containerclassname="margin-bottom-none width width-250px"
                                readOnly={!this.props.displayActive}
                                box="number"
                                value={FormatCurrencyWithoutSymbol({number: val})}
                                onValueChange={({value}) => {
                                    let target = {value: value};
                                    this.handleRowValueChange(rowIndex, "offTheRoad", target)
                                }}
                            />
                        );
                    }
                },
            },
        },
        {
            name: "saved",
            label: "Action",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <FlexView style={{gap: "10px"}}>
                        {val && (
                            <SimpleButton
                                type="button"
                                category="action_button"
                                style={{backgroundColor: "transparent"}}
                                icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-pencil-alt"/>}
                                onClick={() => this.handleChangeSavedState(rowIndex)}
                            />
                        )}
                        {!val && (
                            <SimpleButton
                                type="button"
                                category="action_button"
                                style={{backgroundColor: "transparent"}}
                                icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-save"/>}
                                onClick={() => this.handleCheckVariant(rowIndex)}
                            />
                        )}
                        <SimpleButton
                            type="button"
                            category="action_button"
                            style={{backgroundColor: "transparent"}}
                            icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-trash"/>}
                            onClick={() => this.handleDeleteAlertModalVisibility(rowIndex)}
                        />
                    </FlexView>
                ),
                setCellProps: () => ({width: "10%"}),
                sort: false,
            },
        },
    ];

    handleCheckVariant = (rowIndex) => {
        let kodeVariant = this.state.dataToDetail[rowIndex].kodeVariant;
        let listVariant = this.state.dataToDetail.filter((i, idx) => idx !== rowIndex).map(i => i.kodeVariant);
        if (!R.isNil(kodeVariant)) {
            if (listVariant.includes(kodeVariant)) {
                return this.handleDuplicateVariantAlert();
            }
            this.handleChangeSavedState(rowIndex);
        }
    };

    handleChangeSavedState = (rowIndex) => {
        let updatedData = this.state.dataToDetail.map((item, index) => {
            if (index === rowIndex) {
                return {
                  ...item,
                  ...(!item.namaVariant && item.kodeVariant
                    ? {
                        namaVariant: this.findLabel(
                          this.state.dataToDetail[rowIndex].kodeVariant,
                          this.state.dataVariant
                        )?.label,
                      }
                    : {}),
                  saved: !item.saved,
                };
            }
            return item;
        });
        this.setState(prevState => ({
            ...prevState,
            dataToDetail: updatedData,
        }));
    };

    handleRemoveRow = (rowIndex) => {
        this.setState((prevState) => {
            const dataToDetail = [...prevState.dataToDetail];
            dataToDetail.splice(rowIndex, 1);
            return {dataToDetail, deleteAlert: !prevState.deleteAlert};
        });
    };

    handleGlobalValueChange = (input, event) => {
        let value = '';
        if (!R.isNil(event)) {
            value = Array.isArray(event)
                ? event.map((item) => item.value)
                : event.value;
        }

        this.setState((prevState) => ({
            ...prevState,
            dataToStore: {
                ...prevState.dataToStore,
                [input]: value,
            },
        }));
    };

    handleChekVariant = (input, event) => {
        this.setState((prevState) => ({
            ...prevState,
            checkVariant: event.value,
        }));
    };

    handleRowValueChange = (rowIndex, input, event) => {
        if (input === "namaVariant") {
            this.setState((prevState) => {
                const updatedData = [...prevState.dataToDetail];
                updatedData[rowIndex] = {
                    ...updatedData[rowIndex],
                    kodeVariant: event.value,
                };
                return {
                    ...prevState,
                    dataToDetail: updatedData,
                };
            });
            return;
        }

        if (input === "kodeVariant") {
            this.setState((prevState) => {
                const updatedData = [...prevState.dataToDetail];
                updatedData[rowIndex] = {
                    ...updatedData[rowIndex],
                    kodeVariant: event.value,
                    namaVariant: event.namaVariant,
                };
                return {
                    ...prevState,
                    dataToDetail: updatedData,
                };
            });
            return;
        }

        this.setState((prevState) => {
            const updatedData = [...prevState.dataToDetail];
            updatedData[rowIndex] = {
                ...updatedData[rowIndex],
                [input]: event.value,
            };
            return {
                ...prevState,
                dataToDetail: updatedData,
            };
        });
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            uploadFileModalVisible: false,
            printModalVisible: false,
            dataMainDealer: [],
            dataVariant: [],
            dataToStore: {},
            dataToDetail: [],
            dataBackup: [],
            dataFromDb: {},
            previewDocumentCode: "",
            checkVariant: null,
            isLoading: false,
            rowsPerPage: 5,
            page: 0,
            simpleAlert: false,
            saveAlert: false,
            formRef: null,
            errorMessage: {},
            deleteAlert: false,
            selectedRowIndex: null,
            saveSubmitAlert: false,
            duplicateVariant: false,
            keyword: null,
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        };
    }

    async componentDidMount() {
        this.handleTriggerLoading();
        if (this.props.id.trim() !== "") {
            const {id} = this.props;
            const response = await Api.create(
                "NAGAMAS_MASTER_DATA"
            ).getMasterUnitPriceById(id);
            if (response.ok) {
                let {data} = response.data;
                this.setState((prevValue) => ({
                    dataFromDb: {
                        ...data,
                        mainDealer: data.supplierDto.supplierCode,
                    },
                    pagination: {
                    ...prevValue.pagination,
                    totalData: response.data.data.length,
                }
                }));
                this.mapData(response.data.data);
            }
        } else {
            const body = {
                seqType: "MasterUnitPrice",
                nosDealerCode: this.props.kodeCabang.value,
                transactionType: "MasterUnitPrice",
            };
            const response = await Api.create(
                "NAGAMAS_MASTER_DATA"
            ).getPreviewBarcode(body);
            const text = response.data;
            if (response.ok) {
                this.setState((pevValue) => ({
                    ...pevValue,
                    previewDocumentCode: text,
                }));
            }
            this.setState((prevState) => ({
                ...prevState,
                dataToStore: {
                    ...prevState.dataToStore,
                    kodeCabang: this.props.kodeCabang.value,
                },
            }));
        }
        await this.fetchMainDealer();
        this.handleTriggerLoading();
    }

    mapData = (data) => {
        const {
            kodeDocument,
            localDate,
            supplierDto,
            cabangResponseDTOList,
            responseMasterUnitDetails,
        } = data;
        if (data) {
            this.setState((prevState) => ({
                ...prevState,
                dataToStore: {
                    ...prevState.dataToStore,
                    kodeDocument: kodeDocument,
                    mainDealer: supplierDto.supplierCode,
                    expiredDate: M(localDate).format("DD-MM-YYYY"),
                    cabangBerlaku: cabangResponseDTOList.map((item) => item.kodeCabang),
                },
                dataToDetail: responseMasterUnitDetails.map((item) => ({
                    kodeVariant: item.variantAndTypeDTO.kodeVariant,
                    namaVariant: item.variantAndTypeDTO.namaVariant,
                    onTheRoad: item.onTheRoad,
                    offTheRoad: item.offTheRoad,
                    saved: true,
                })),
            }));
        }
    };

    handleUploadFileModalVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            uploadFileModalVisible: !prevState.uploadFileModalVisible,
        }))
    }

    fetchMainDealer = async () => {
        const [responseMainDealer, responseVariant] = await Promise.all([
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSupplierMainDealer,
                menuName: "Master Unit Price",
                setError: this.props.setError,
                args: contructQueryParam({kodeCabang: this.props.kodeCabang.value}),
            }),
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllVariant,
                menuName: "Master Unit Price",
                setError: this.props.setError,
            }),
        ]);
        if (responseMainDealer.ok && responseVariant.ok) {
            const dataMainDealer = responseMainDealer.data.data.map((item) => ({
                label: item.supplierName,
                value: item.supplierCode,
            }));
            const dataVariant = responseVariant.data.data.map((item) => ({
                label: item.namaVariant,
                value: item.kodeVariant,
            }));
            this.setState((prevState) => ({
                ...prevState,
                dataMainDealer: dataMainDealer,
                dataVariant: dataVariant,
            }));
        }
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    handleInputDateChange = (name, value) => {
        this.setState((prevState) => ({
            ...prevState,
            dataToStore: {
                ...this.state.dataToStore,
                [name]: M(value).format("DD-MM-YYYY"),
            },
        }));
    };

    findLabel = (value, options) => {
        if (!value) return "";
        if (Array.isArray(value)) {
            return value
                .map((value) => options.find((item) => item.value === value))
                .filter((item) => item);
        }
        const label = options.find((item) => item.value === value);
        return label ? label : "";
    };

    handleAddRow = () => {
        const newRow = {
            kodeVariant: null,
            namaVariant: null,
            onTheRoad: null,
            offTheRoad: null,
            saved: false,
        };
        this.setState((prevState) => ({
            ...prevState,
            dataToDetail: [...prevState.dataToDetail, newRow],
        }));
    };

    handleClose = () => {
        this.setState(
            (prevState) => ({
                ...prevState,
                dataToDetail: [],
                dataToStore: {},
            }),
            () => {
                this.props.handleDisplatActive();
                this.props.onClose();
            }
        );
    };

    handleBeforeSubmit = (text) => {
        if (this.validate()) {
            return;
        }

        this.handleSaveSubmitAlertModalVisibility(text)
    }

    handleSubmit = () => {
        const dataToDetail = this.state.dataToDetail.map((item) => ({
            kodeVariant: item.kodeVariant,
            onTheRoad: parseFloat(item.onTheRoad),
            offTheRoad: parseFloat(item.offTheRoad),
        }));
        const seen = new Set();
        let hadDuplicate = dataToDetail.some(item => {
            if (seen.has(item.kodeVariant)) {
                return true;
            }
            seen.add(item.kodeVariant);
            return false;
        })
        if (hadDuplicate) {
            return this.handleDuplicateVariantAlert();
        }
        if (!R.isEmpty(this.state.dataBackup)) {
            const dataBackup = this.state.dataBackup.map((item) => ({
                kodeVariant: item.kodeVariant,
                onTheRoad: item.onTheRoad,
                offTheRoad: item.offTheRoad,
            }));
            dataToDetail.push(...dataBackup);
        }
        const body = {
            ...this.state.dataToStore,
            detail: dataToDetail
        };
        this.props.onSubmit(body);
    };

    validate = () => {
        const newErrors = {};
        const mandatoryField = ['mainDealer', 'expiredDate', 'cabangBerlaku']
        const {dataToStore} = this.state;
        mandatoryField.forEach((field) => {
            if (R.or(!dataToStore[field], R.isEmpty(dataToStore[field]))) {
                newErrors[field] = "Field Belum Diisi!";
            }
        });

        const {dataToDetail} = this.state;
        dataToDetail.forEach(item => {
            if (R.or(!item.kodeVariant, R.isEmpty(item.kodeVariant))) {
                newErrors["kodeVariant"] = {
                    index: dataToDetail.indexOf(item),
                    message: "Field Belum Diisi!"
                };

                this.handleSaveAlertModalVisibility("Ada field data yang perlu diisi atau tidak sesuai kriteria isian.");
            }
        })

        this.setState((prevState) => ({
            ...prevState,
            errorMessage: {
                ...prevState.errors,
                ...newErrors,
            },
        }))

        return Object.keys(newErrors).length !== 0;
    }

    handleDeleteConfirmation = (e) => {
        e.preventDefault();
        this.setState({simpleAlert: false}, () => {
            this.handleSubmit(e);
        });
    };

    handleSaveAlertModalVisibility = (text) => {
        this.setState((prevState) => ({
            ...prevState,
            warningMessage: text,
            saveAlert: !prevState.saveAlert,
        }));
    };

    handleDeleteAlertModalVisibility = (rowIndex) => {
        const data = this.state.dataToDetail[rowIndex];
        const variant = this.state.dataVariant.find(item => item.value === data?.kodeVariant);
        const text = "Apakah anda yakin ingin menghapus data Harga " + variant?.label + " ?";
        this.setState((prevState) => ({
            ...prevState,
            warningMessage: text,
            deleteAlert: !prevState.deleteAlert,
            selectedRowIndex: rowIndex,
        }));
    };

    handleSaveSubmitAlertModalVisibility = (text) => {
        this.setState((prevState) => ({
            ...prevState,
            warningMessage: text,
            saveSubmitAlert: !prevState.saveSubmitAlert,
        }));
    };


    checkIfDelete = () => {
        this.setState((prevState) => ({
            ...prevState,
            simpleAlert: !prevState.simpleAlert,
        }));
    };

    filterData = () => {
        this.setState({
            keyword: this.state.checkVariant
        })
    };

    resetData = () => {
       this.setState(prev=>({
        ...prev,
        keyword: null,
        checkVariant: null
       }))
    };

    handlePrint = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            printModalVisible: !prevValue.printModalVisible
        }));
    }

    handleOnSubmitFile = async (file) => {
        try {
            this.handleTriggerLoading();
            const renamedFile = new File([file], "HARGA_UNIT.xlsx", {
                type: file.type,
            });

            const formData = new FormData();
            formData.append("file", renamedFile);
            console.log(formData);
            

            let res = await Api.create("NAGAMAS_MASTER_DATA").uploadTemplateMasaterUnitPrice(formData);
            if (res.ok) {
                if (res.data.status === HttpStatus.FAILED) {
                    this.handleTriggerLoading();
                    return checkAndHandleError(res, this.props.setError, "Master Unit Price");
                } else if (res.data.status === HttpStatus.SUCCESS) {
                    const transformedData = res.data.data.map(item => ({
                        kodeVariant: item["Kode Varian"],
                        onTheRoad: item["On The Road"],
                        offTheRoad: item["Off The Road"],
                    }));

                    let dataTable = this.state.dataToDetail;
                    transformedData.forEach(item => {
                        const existingItemIndex = dataTable.findIndex(dataTableItem => dataTableItem.kodeVariant === item.kodeVariant);
                        console.log("existingItemIndex: ", existingItemIndex)
                        if (existingItemIndex !== -1) {
                            dataTable[existingItemIndex] = {
                                ...dataTable[existingItemIndex],
                                onTheRoad: item.onTheRoad + dataTable[existingItemIndex].onTheRoad,
                                offTheRoad: item.offTheRoad + dataTable[existingItemIndex].offTheRoad
                            };
                        } else {
                            dataTable = [...dataTable, item];
                        }
                    });

                    this.setState((prevState) => ({
                        ...prevState,
                        dataToDetail: dataTable,
                    }));


                    this.handleTriggerLoading();
                    return true;
                }
            }

        } catch (error) {
            console.log("error: ", error)
        }

        this.handleTriggerLoading();
        return false;
    }

    handleDownloadLogError = async () => {
        try {
            const res = await Api.create("NAGAMAS_MASTER_DATA_FILE").downloadLogErrorTemplateMasaterUnitPrice();
            if (res.ok) {
                if (checkAndHandleError(res, this.props.setError, "Master Unit Price")) return;
                const blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "HARGA_UNIT_LOG.xlsx"; // Set the desired file name
                document.body.appendChild(a);
                a.click();

                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.log("error: ", error);
        }
    }

    handleDownloadTemplate = async () => {
        try {
            const res = await Api.create("NAGAMAS_MASTER_DATA_FILE").downloadTemplateMasaterUnitPrice();
            if (res.ok) {
                if (checkAndHandleError(res, this.props.setError, "Master Unit Price")) return;
                const blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "HARGA_UNIT.xlsx";
                document.body.appendChild(a);
                a.click();

                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.log("error: ", error);
        }
    }

    handleDuplicateVariantAlert = () => {
        this.setState((prevState) => ({
            ...prevState,
            duplicateVariant: !prevState.duplicateVariant,
            saveSubmitAlert: false,
        }));
    }

    getDataDetail = () => {
      const {keyword} = this.state;
      if(keyword){
        return this.state.dataToDetail.filter(
          (item) => item.kodeVariant.includes(keyword)
        )
      }
      return this.state.dataToDetail
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        const {optionCabang} = this.props;
        const {display} = this.props;
        const {pagination} = this.state;
        return (
            <SimpleModal
                title={"HARGA MOTOR " + display}
                visible={this.props.visible}
                onClickClose={this.handleClose}
                width="800px"
                height="600px"
                content={
                    <ModalContainer>
                        <form ref={(ref) => (this.formRef = ref)} onSubmit={this.handleSubmit}>
                            <FlexView column marginBottom={20}>
                                <div className="grid grid-2x grid-mobile-none gap-20px">
                                    <div id="grid-1">
                                        <label htmlFor="input_text_kode_document">
                                            Kode Document
                                        </label>
                                        <SimpleInput
                                            id="input_text_kode_document"
                                            name="kodeDocument"
                                            containerclassname="width width-250px"
                                            readOnly={true}
                                            value={
                                                this.state.previewDocumentCode
                                                    ? this.state.previewDocumentCode
                                                    : this.state.dataFromDb.kodeDocument
                                            }
                                            onChange={(e) =>
                                                this.handleGlobalValueChange("kodeDocument", e)
                                            }
                                        />
                                        <SimpleDDL
                                            id="ddl_main_dealer"
                                            name="mainDealer"
                                            label="Main Dealer"
                                            containerclassname="width width-250px"
                                            box="search"
                                            readOnly={!this.props.displayActive}
                                            mandatory
                                            errorMessage={this.state.errorMessage?.mainDealer}
                                            options={this.state.dataMainDealer}
                                            value={this.findLabel(
                                                this.state.dataToStore.mainDealer
                                                    ? this.state.dataToStore.mainDealer
                                                    : this.state.dataFromDb.mainDealer,
                                                this.state.dataMainDealer
                                            )}
                                            onChange={(e) =>
                                                this.handleGlobalValueChange("mainDealer", e)
                                            }
                                        />
                                        <div className="width-150px" style={{width: "250px"}}>
                                            <SimpleDate
                                                label="Tanggal Berlaku"
                                                id="select_date_to"
                                                style={{width: "100%"}}
                                                mandatory
                                                errorMessage={this.state.errorMessage?.expiredDate}
                                                disabled={!this.props.displayActive}
                                                date={this.state.dataToStore.expiredDate}
                                                onChange={(value) =>
                                                    this.handleInputDateChange("expiredDate", value)
                                                }
                                            />
                                        </div>
                                        <SimpleDDL
                                            id="select_options_untuk_cabang"
                                            label="Cabang Berlaku"
                                            name="cabangBerlaku"
                                            containerclassname="width width-250px"
                                            box="multiselect"
                                            mandatory
                                            errorMessage={this.state.errorMessage?.cabangBerlaku}
                                            readOnly={!this.props.displayActive}
                                            options={optionCabang}
                                            value={this.findLabel(
                                                this.state.dataToStore.cabangBerlaku
                                                    ? this.state.dataToStore.cabangBerlaku
                                                    : this.state.dataFromDb.cabangBerlaku,
                                                optionCabang
                                            )}
                                            onChange={(e) =>
                                                this.handleGlobalValueChange("cabangBerlaku", e)
                                            }
                                        />
                                    </div>
                                </div>
                            </FlexView>
                            <FlexView vAlignContent="center"
                                      style={{gap: "10px", marginBottom: "15px", justifyContent: "space-between"}}>
                                <SimpleButton
                                    text="Tambah"
                                    type="button"
                                    onClick={this.handleAddRow}
                                />
                                <FlexView>
                                    <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                        <p>Check Kode Variant</p>
                                        <SimpleInput
                                            id="input_text_check_variant"
                                            name="checkVariant"
                                            containerclassname="margin-bottom-none"
                                            placeholder="Kode Variant"
                                            value={this.state.checkVariant}
                                            onChange={(e) => {
                                                const {target} = e;
                                                this.handleChekVariant("checkVariant", target);
                                            }}
                                        />
                                    </FlexView>
                                    <SimpleButton
                                        className="margin-top-5px"
                                        text="Cari"
                                        type="button"
                                        onClick={this.filterData}
                                    />
                                    <SimpleButton
                                        className="margin-top-5px"
                                        type="button"
                                        text="Reset"
                                        onClick={this.resetData}
                                    />
                                </FlexView>
                            </FlexView>
                            <SimpleDataTable
                                key={`${pagination.totalData}-${pagination.page}`}
                                columns={this.tableColumns}
                                data={this.getDataDetail()}
                                toCount={pagination.totalData}
                                rowsPerPage={pagination.limit}
                                page={pagination.page - 1}
                                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                            />
                            {this.props.displayActive && (
                                <div style={{textAlign: "right", marginTop: "10px"}}>
                                    <SimpleButton
                                        text="Upload"
                                        type="button"
                                        onClick={this.handleUploadFileModalVisibility}
                                    />
                                    <SimpleButton
                                        text="Cetak"
                                        type="button"
                                        onClick={this.handlePrint}
                                    />
                                    <SimpleButton
                                        text="Simpan"
                                        type="button"
                                        onClick={() => this.handleBeforeSubmit("Apakah anda yakin ingin menyimpan data Harga Motor?")}
                                    />
                                </div>
                            )}
                            {!this.props.displayActive && (
                                <div style={{textAlign: "right", marginTop: "10px"}}>
                                    <SimpleButton
                                        text="Hapus"
                                        type="button"
                                        onClick={this.checkIfDelete}
                                    />
                                </div>
                            )}
                            {this.state.simpleAlert && (
                                <SimpleAlert
                                    visible={this.state.simpleAlert}
                                    onClickClose={() => this.checkIfDelete()}
                                    content={
                                        <div>
                                            <p>Apakah anda yakin ingin menghapus dokumen ini?</p>
                                        </div>
                                    }
                                    additionalButtons={
                                        <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                            <SimpleButton
                                                secondary
                                                onClick={() => this.checkIfDelete()}
                                            >
                                                Batal
                                            </SimpleButton>
                                            <SimpleButton
                                                onClick={this.handleDeleteConfirmation}
                                                type="button"
                                            >
                                                Iya
                                            </SimpleButton>
                                        </FlexView>
                                    }
                                />
                            )}
                            {this.state.saveAlert && (
                                <SimpleAlert
                                    title={"Information"}
                                    content={
                                        <div>
                                            <p>
                                                {this.state.warningMessage}
                                                <br/>
                                                Mohon periksa kembali.
                                            </p>
                                        </div>
                                    }
                                    visible={this.state.saveAlert}
                                    onClickClose={this.handleSaveAlertModalVisibility}
                                    additionalButtons={
                                        <SimpleButton
                                            type="button"
                                            text="OK"
                                            onClick={() => this.handleSaveAlertModalVisibility()}
                                        />
                                    }
                                />
                            )}
                            {this.state.deleteAlert && (
                                <SimpleAlert
                                    title={"Information"}
                                    content={
                                        <div>
                                            <p>
                                                {this.state.warningMessage}
                                            </p>
                                        </div>
                                    }
                                    visible={this.state.deleteAlert}
                                    onClickClose={this.handleDeleteAlertModalVisibility}
                                    additionalButtons={
                                        <FlexView vAlignContent="center" style={{alignItems: "end"}}>
                                            <SimpleButton
                                                type="button"
                                                text="Batal"
                                                onClick={() => this.handleDeleteAlertModalVisibility()}
                                            />
                                            <SimpleButton
                                                type="button"
                                                text="OK"
                                                onClick={() => this.handleRemoveRow(this.state.selectedRowIndex)}
                                            />
                                        </FlexView>
                                    }
                                />
                            )}
                            {this.state.saveSubmitAlert && (
                                <SimpleAlert
                                    title={"Information"}
                                    content={
                                        <div>
                                            <p>
                                                {this.state.warningMessage}
                                            </p>
                                        </div>
                                    }
                                    visible={this.state.saveSubmitAlert}
                                    onClickClose={this.handleSaveSubmitAlertModalVisibility}
                                    additionalButtons={
                                        <FlexView vAlignContent="center" style={{alignItems: "end"}}>
                                            <SimpleButton
                                                type="button"
                                                text="Batal"
                                                onClick={() => this.handleSaveSubmitAlertModalVisibility()}
                                            />
                                            <SimpleButton
                                                type="button"
                                                text="OK"
                                                onClick={() => this.handleSubmit()}
                                            />
                                        </FlexView>
                                    }
                                />
                            )}
                            {this.state.duplicateVariant && (
                                <SimpleAlert
                                    title={"Peringatan"}
                                    content={"Data Varian sudah terdapat pada list. Mohon dicek kembali"}
                                    visible={this.state.duplicateVariant}
                                    onClickClose={this.handleDuplicateVariantAlert}
                                    additionalButtons={
                                        <SimpleButton
                                            type="button"
                                            text="OK"
                                            onClick={this.handleDuplicateVariantAlert}
                                        />
                                    }
                                />
                            )}
                        </form>

                        {this.state.uploadFileModalVisible && (
                            <SimpleUploadExcel
                                downloadError={true}
                                visible={this.state.uploadFileModalVisible}
                                onChange={this.handleOnSubmitFile}
                                onDownloadTemplate={this.handleDownloadTemplate}
                                onDownloadLogError={this.handleDownloadLogError}
                                onClickClose={() => this.handleUploadFileModalVisibility()}
                            />

                        )}

                        <SimpleLoadingOverlay active={this.state.loading}/>
                        {this.state.printModalVisible && <SimplePrintTable onClearPrint={this.handlePrint}/>}
                    </ModalContainer>
                }
            />
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(MasterUnitPriceModifying);
